import React from "react";
import AggregateRelationInput from "components/Tiles/Sense/Relation/AggregateRelationInput";
import DistinctRelationInput from "components/Tiles/Sense/Relation/DistinctRelationInput";
import FilterRelationInput from "components/Tiles/Sense/Relation/FilterRelationInput";
import JoinRelationInput from "components/Tiles/Sense/Relation/JoinRelationInput";
import UnionRelationInput from "components/Tiles/Sense/Relation/UnionRelationInput";
import MutateRelationInput from "./MutateRelationInput";
import ProjectRelationInput from "./ProjectRelationInput";
import ToggleablePivotingRelationInput from "./ToggleablePivotingRelationInput";
import SQLRelationInput from "./SQLRelationInput";
export const RelationInput = ({ relation, onChange, isDisabled }) => {
    if (relation === undefined) {
        return React.createElement("div", null);
    }
    switch (relation.type) {
        case "AGGREGATE":
            return React.createElement(AggregateRelationInput, { relation: relation, onChange: onChange, isDisabled: isDisabled });
        case "DISTINCT":
            return React.createElement(DistinctRelationInput, { relation: relation, onChange: onChange, isDisabled: isDisabled });
        case "FILTER":
            return React.createElement(FilterRelationInput, { relation: relation, onChange: onChange, isDisabled: isDisabled });
        case "JOIN":
            return React.createElement(JoinRelationInput, { relation: relation, onChange: onChange, isDisabled: isDisabled });
        case "MUTATE":
            return React.createElement(MutateRelationInput, { relation: relation, onChange: onChange, isDisabled: isDisabled });
        case "PROJECT":
            return React.createElement(ProjectRelationInput, { relation: relation, onChange: onChange, isDisabled: isDisabled });
        case "PIVOT":
        case "UNPIVOT":
        case "UNPIVOT_PIVOT":
            return React.createElement(ToggleablePivotingRelationInput, { relation: relation, onChange: onChange, isDisabled: isDisabled });
        case "UNION":
            return React.createElement(UnionRelationInput, { relation: relation, onChange: onChange, isDisabled: isDisabled });
        case "SQL":
            return React.createElement(SQLRelationInput, { relation: relation, onChange: onChange, isDisabled: isDisabled });
    }
    return React.createElement("div", null);
};
export default RelationInput;
